export default {
    namespaced: true,
    state: {
        selectedLanguage: 'pt_BR',
    },
    getters: {
        getLanguageCode(state) {
            return state.selectedLanguage
        },
    },
    mutations: {
        CHANGE_LANGUAGE(state, payload) {
            state.selectedLanguage = payload.langCode
        },
    },
    actions: {
        changeLanguageCode(context, langCode) {
            localStorage.setItem('language', langCode)
            context.commit('CHANGE_LANGUAGE', {
                langCode: langCode,
            })
        },
    },
}
